<script lang="ts" setup name="FooterCopyright">
const currentYear = new Date().getFullYear();
</script>

<template>
  <span class="text-xs text-charcoal-6">
    © {{ currentYear }} G2 Ocean AS. All Rights Reserved
  </span>
</template>
